/* Compacte variantkeuze voor producten met veel uitvoeringen. */
(function () {
  'use strict';

  function selectedOptions(picker) {
    return Array.prototype.map.call(
      picker.querySelectorAll('.variant-group'),
      function (group) {
        var select = group.querySelector('[data-variant-compact-select]');
        if (select) return select.value;
        var checked = group.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      }
    );
  }

  function findVariant(variants, options) {
    return variants.filter(function (variant) {
      return variant.options.every(function (value, index) {
        return value === options[index];
      });
    })[0];
  }

  function money(cents) {
    if (window.Shopify && window.Shopify.formatMoney && window.themeMoneyFormat) {
      return window.Shopify.formatMoney(cents, window.themeMoneyFormat);
    }
    return '\u20ac' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function ensureMobileVariant(section) {
    var price = section && section.querySelector('.product-mobile-buybar__price');
    if (!price) return null;
    var label = price.querySelector('[data-buybar-variant]');
    if (!label) {
      label = document.createElement('span');
      label.className = 'product-mobile-buybar__variant';
      label.setAttribute('data-buybar-variant', '');
      price.appendChild(label);
    }
    return label;
  }

  function init(picker) {
    if (picker.hasAttribute('data-variant-selector-ready')) return;
    picker.setAttribute('data-variant-selector-ready', '');

    var json = picker.querySelector('[data-variants-json]');
    var variants;
    try {
      variants = JSON.parse(json.textContent);
    } catch (error) {
      return;
    }

    var section = picker.closest('section');
    var summaryValue = picker.querySelector('[data-variant-choice-value]');
    var summaryStock = picker.querySelector('[data-variant-choice-stock]');
    var liveStatus = picker.querySelector('[data-variant-live-status]');
    var mobileVariant = ensureMobileVariant(section);
    var productTitle = picker.getAttribute('data-product-title') || '';
    var addLabel = picker.getAttribute('data-add-label') || 'In winkelwagen';
    var inStockLabel = picker.getAttribute('data-in-stock-label') || 'Op voorraad';
    var soldOutLabel = picker.getAttribute('data-sold-out-label') || 'Tijdelijk uitverkocht';
    var unavailableLabel = picker.getAttribute('data-unavailable-label') || 'Deze combinatie is niet beschikbaar';
    var addButtons = section
      ? section.querySelectorAll('[data-product-form] button[type="submit"], [data-buybar-add]')
      : [];
    var productForm = section && section.querySelector('[data-product-form]');
    var deliveryDetails = section && section.querySelector('[data-product-delivery]');
    var productStock = section && section.querySelector('[data-product-stock]');
    var productStockLabel = productStock && productStock.querySelector('[data-product-stock-label]');
    var productGloballyAvailable = !productStock || productStock.dataset.productGloballyAvailable !== 'false';
    var announceTimer = null;

    function accessibleButtonLabel(label) {
      return productTitle ? label + ' — ' + productTitle : label;
    }

    function announce(message) {
      if (!liveStatus || !message) return;
      window.clearTimeout(announceTimer);
      liveStatus.textContent = '';
      announceTimer = window.setTimeout(function () {
        liveStatus.textContent = message;
      }, 80);
    }

    function setProductStock(isAvailable, label) {
      if (!productStock) return;
      productStock.dataset.available = String(isAvailable);
      if (productStockLabel) productStockLabel.textContent = label;
    }

    function setPurchaseAvailability(isAvailable, label, price) {
      var submitting = productForm && productForm.dataset.submitting === 'true';
      Array.prototype.forEach.call(addButtons, function (button) {
        if (button.hasAttribute('data-buybar-add')) {
          button.dataset.variantAvailable = String(isAvailable);
        }
        button.disabled = submitting || !isAvailable;
        button.setAttribute('aria-disabled', submitting || !isAvailable ? 'true' : 'false');
        var visibleLabel = submitting ? 'Bezig…' : label;
        if (!submitting && isAvailable && price != null && !button.hasAttribute('data-buybar-add')) {
          visibleLabel += ' — ' + money(price);
        }
        button.setAttribute('aria-label', accessibleButtonLabel(visibleLabel));
        button.textContent = visibleLabel;
      });
      if (deliveryDetails) deliveryDetails.hidden = !isAvailable;
    }

    function refresh(announceChange) {
      var options = selectedOptions(picker);
      var variant = findVariant(variants, options);
      if (!variant) {
        var unavailableDescription = options.filter(Boolean).join(' / ');
        if (summaryValue) summaryValue.textContent = unavailableDescription;
        if (summaryStock) {
          summaryStock.textContent = unavailableLabel;
          summaryStock.setAttribute('data-available', 'false');
        }
        if (mobileVariant) {
          mobileVariant.textContent = unavailableDescription;
          mobileVariant.hidden = !unavailableDescription;
        }
        setProductStock(false, unavailableLabel);
        setPurchaseAvailability(false, unavailableLabel);
        if (announceChange) {
          announce('Gekozen: ' + unavailableDescription + '. ' + unavailableLabel + '.');
        }
        return;
      }

      var description = variant.options.join(' / ');
      var isDefault = description === 'Default Title';
      var effectiveAvailable = productGloballyAvailable && variant.available;
      var availabilityLabel = effectiveAvailable ? inStockLabel : soldOutLabel;

      if (summaryValue) summaryValue.textContent = description;
      if (summaryStock) {
        summaryStock.textContent = availabilityLabel;
        summaryStock.setAttribute('data-available', effectiveAvailable ? 'true' : 'false');
      }
      if (mobileVariant) {
        mobileVariant.textContent = isDefault ? '' : description;
        mobileVariant.hidden = isDefault;
      }
      setProductStock(effectiveAvailable, availabilityLabel);
      setPurchaseAvailability(effectiveAvailable, effectiveAvailable ? addLabel : soldOutLabel, variant.price);
      if (announceChange) {
        announce('Gekozen: ' + description + '. Prijs: ' + money(variant.price) + '. ' +
          availabilityLabel + '.');
      }
    }

    picker.querySelectorAll('[data-variant-compact-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var group = select.closest('.variant-group');
        var radios = Array.prototype.slice.call(group.querySelectorAll('input[type="radio"]'));
        var proxy = radios.filter(function (radio) { return radio.value === select.value; })[0];
        if (!proxy) return;
        proxy.checked = true;
        proxy.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    picker.addEventListener('change', function () { refresh(true); });
    refresh(false);
  }

  function boot() {
    document.querySelectorAll('[data-variant-picker]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
